import { lazy } from "react";

// route
export const mitraSCMRoute = { path: "/mitra", name: "mitra.", icon: "people" };
export const mitraSearchRoute = { path: `${mitraSCMRoute.path}/search`, name: "mitra.menu.search" };
export const mitraConfirmationRoute = { path: `${mitraSCMRoute.path}/confirmation`, name: "mitra.menu.confirmation" };
export const mitraListRoute = { path: `${mitraSCMRoute.path}/list`, name: "mitra_list." };
export const mitraProductListRoute = { path: `${mitraListRoute.path}/product_list`, name: "mitra.menu.product" };
export const mitraOwnProductListRoute = { path: `${mitraListRoute.path}/own_product_list`, name: "mitra.menu.product_own" };
export const mitraStockReqRoute = { path: `${mitraSCMRoute.path}/stock_request`, name: "mitra_stock_req." };
export const mitraAddStckReqRoute = { path: `${mitraStockReqRoute.path}/add`, name: "mitra_stock_req.add" };
export const mitraEditStckReqRoute = { path: `${mitraStockReqRoute.path}/edit`, name: "mitra_stock_req.edit" };
export const mitraViewtStckReqRoute = { path: `${mitraStockReqRoute.path}/view`, name: "mitra_stock_req.detail" };

// component
const MitraSCM = lazy(() => import("../page/mitra/MitraSCM"));
const MitraSCM2 = lazy(() => import("../page/mitra/MitraSCM2"));
const MitraSearch = lazy(() => import("../page/mitra/search/MitraSearch"));
const MitraConfirmation = lazy(() => import("../page/mitra/confirmation/MitraConfirmation"));
const MitraList = lazy(() => import("../page/mitra/list/MitraList"));
const MitraProductList = lazy(() => import("../page/mitra/list/MitraProductList"));
const MitraOwnProductList = lazy(() => import("../page/mitra/list/MitraOwnProductList"));
const MitraStockRequest = lazy(() => import("../page/mitra/stock_request/MitraStockRequest"));
const MitraFromStockRequest = lazy(() => import("../page/mitra/stock_request/form/MitraFromStockReq"));
const MitraViewStockRequest = lazy(() => import("../page/mitra/stock_request/MitraViewStockReq"));

export const mitraTabRoute = [mitraSearchRoute, mitraConfirmationRoute];
export const mitraListRoutes = [mitraSearchRoute, mitraListRoute, mitraStockReqRoute];
export const mitraMutationRutes = [
    mitraListRoute, mitraStockReqRoute, mitraAddStckReqRoute,
    mitraProductListRoute, mitraOwnProductListRoute
]

export const mitarSCMRoutes = [
    {
        element: <MitraSCM />,
        children: [
            { ...mitraSearchRoute, element: <MitraSearch /> },
            { ...mitraConfirmationRoute, element: <MitraConfirmation /> },
        ],
    },
    {
        element: <MitraSCM2 />,
        children: [
            { ...mitraListRoute, element: <MitraList /> },
            { ...mitraProductListRoute, element: <MitraProductList /> },
            { ...mitraOwnProductListRoute, element: <MitraOwnProductList /> },
            { ...mitraStockReqRoute, element: <MitraStockRequest /> },
            { ...mitraAddStckReqRoute, element: <MitraFromStockRequest type="add" /> },
            { ...mitraEditStckReqRoute, element: <MitraFromStockRequest type="edit" /> },
            { ...mitraViewtStckReqRoute, element: <MitraViewStockRequest /> },
        ],
    }
];